import React from "react";
import GradientGlowDivider from "../../../../../Components/GradientGlowDivider";

const ApproachCard = ({ title, description, imageUrl, left = false }) => {
  const pointList = [
    {
      title: "Strategic AI Planning",
      description:
        "Defining tailored AI strategies (Data, Use Cases, Platform, People) aligned with your business objectives",
    },
    {
      title: "Rapid Prototyping",
      description:
        "Developing high-value use cases to demonstrate immediate impact.",
    },
    {
      title: "Scalable Implementation",
      description:
        "Scaling successful solutions into production workflows and upskilling/building in house teams.",
    },
  ];

  return (
    <div
      className={`flex flex-col ${
        left ? "md:flex-row md:space-x-16" : "md:flex-row-reverse"
      } space-y-12 md:space-y-0  justify-center items-center`}
    >
      <div className="flex flex-col items-start md:px-1">
        <div className="space-y-6">
          {pointList.map((point, index) => (
            <div className="flex flex-col">
              <div className="flex flex-row items-start space-x-4">
                <h1 className="text-lg md:text-xl leading-[145%] tracking-[0%] font-bold pt-0.5">
                  {String(index + 1).padStart(2, "0")}
                </h1>
                <div className="flex flex-col items-start pt-0.5">
                  <div className="flex flex-row items-center justify-center space-x-1 mb-0.5">
                    <h1 className="text-lg md:text-xl leading-[145%] tracking-[0%] font-bold">
                      {point.title}
                    </h1>
                  </div>
                  <p className="md:text-lg leading-[145%] tracking-[0%]">
                    {point.description}
                  </p>
                </div>
              </div>
              <div className="pt-6 w-full mx-auto">
                <GradientGlowDivider />
              </div>
            </div>
          ))}
        </div>
      </div>

      {!left && <div className="md:w-16"></div>}

      <div
        className={`relative overflow-hidden text-white h-[480px] w-full md:w-auto md:min-w-[50%] flex flex-row`}
      >
        <img
          src={imageUrl}
          alt="AI Strategy"
          className="w-full h-full object-cover absolute object-center grayscale"
        />
        {/* Top Shadow */}
        <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-app-background to-transparent z-10" />

        {/* Bottom Shadow */}
        <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-app-background to-transparent z-10" />

        {/* Left Shadow */}
        <div className="absolute top-0 left-0 h-full w-20 bg-gradient-to-r from-app-background to-transparent z-10" />

        {/* Right Shadow */}
        <div className="absolute top-0 right-0 h-full w-20 bg-gradient-to-l from-app-background to-transparent z-10" />
      </div>
    </div>
  );
};

export default ApproachCard;
